import {
  call,
  put,
  takeEvery,
  select,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  getHotelFailure,
  getHotelSuccess,
  getHotelRequest,
  setIsUserInteractedWithHotelList,
  deepLinkSearchSucess,
  setHotelDetailLoading,
} from '../../slices/hotel';
import formatHotelDetailRequest from '../../../helpers/formatHotelDetailRequest';
import { searchSuccess } from '../../slices/tripSearch';
import { hotelAutocompleteRequest } from '../../slices/autocomplete';
import { getAutocompleteType } from '../../../constants';

const queryString = require('query-string');

function* getHotelWorker({
  payload: {
    itinerary,
    tripId,
    isTravelOption,
    currencyCode,
    shopKeyForAdditionalRooms = undefined,
    doSearchHotelWithDeeplink = false,
    isDedicatedHotelPage = false,
  },
}) {
  try {
    yield put(setIsUserInteractedWithHotelList(true));
    const { staterooms } = yield select((store) => (isDedicatedHotelPage
      ? store.tripSearch.searchInputs : store.tripSearch.searchObj));
    const { travelAgency } = yield select((store) => store.user);
    const { hotelRateCodes, isViewingCompare } = yield select((store) => store.compare);
    const { currencyCode: currencyCodeStored } = yield select((store) => store.tripSearch);
    let searchObj = yield select((store) => (!isTravelOption
      ? (store.hotel.hotelSearches[tripId] || {}).searchObj : store.tripSearch.searchObj.hotel));
    if (isViewingCompare) {
      searchObj = {
        rateCodes: hotelRateCodes,
        doShowCommissionableRatesOnly: travelAgency && travelAgency.filterSettings
          && travelAgency.filterSettings.doShowCommissionableRatesOnly,
        showRefundableHotelRatesOnly: travelAgency?.filterSettings?.showRefundableHotelRatesOnly,
        exactMatchRateCodesOnly: travelAgency && travelAgency.filterSettings
          && travelAgency.filterSettings.doShowOnlyPreferredRatesForCompare,
        doShowAvailableHotelsOnly: !travelAgency || !travelAgency.filterSettings
          || travelAgency.filterSettings.doShowAvailableHotelsOnly,
      };
    }
    const request = formatHotelDetailRequest(itinerary,
      staterooms, searchObj, isDedicatedHotelPage);
    const qs = queryString.stringify({
      ...request, currencyCode: currencyCode || currencyCodeStored || undefined,
    }, { skipNull: true });
    const responses = yield select((store) => store.hotel.hotelDetailResponses);
    let responseData = responses[qs];
    if ((!responseData || shopKeyForAdditionalRooms) || isDedicatedHotelPage) {
      let url = `/hotels/getHotel?${qs}`;
      if (shopKeyForAdditionalRooms && shopKeyForAdditionalRooms.length > 0) {
        url += `&${queryString.stringify({ shopKeyForAdditionalRooms })}`;
      }
      const config = {
        method: 'get',
        url,
      };
      const { data } = yield call(axios, config);
      if (data) {
        responseData = {
          ...data,
        };
      }
    }
    if (responseData) {
      yield put(getHotelSuccess({
        itinerary,
        response: responseData,
        searchKey: qs,
        shopKeyForAdditionalRooms,
        doSearchHotelWithDeeplink,
      }));
    } else {
      yield put(getHotelFailure({ itinerary, shopKeyForAdditionalRooms, error: 'Problem in searching hotel details!' }));
    }
    if (doSearchHotelWithDeeplink || isDedicatedHotelPage) {
      if (responseData) {
        const transformedData = {
          travelOptions: [
            {
              hotelItinerary: responseData,
              mode: responseData.mode,
              key: responseData.hotelKey,
            },
          ],
        };
        let query = `${responseData.hotel.name}`;
        if (responseData.hotel.city) query += `, ${responseData.hotel.city}`;
        if (responseData.hotel.stateCode) query += `, ${responseData.hotel.stateCode}`;
        query += `, ${responseData.hotel.country}`;

        const { doPrioritizeHotelsOnAutoCompleteResults } = travelAgency?.settings || {};
        const autocompleteType = getAutocompleteType(
          { doPrioritizeHotelsOnAutoCompleteResults },
        );
        yield put(hotelAutocompleteRequest({
          autocompleteTypes: autocompleteType.HOTELS,
          responseType: 'HotelsAutocompleteResults',
          query,
        }));
        yield put(searchSuccess(transformedData));
        yield put(setHotelDetailLoading(false));
      }
      if (!isDedicatedHotelPage) {
        yield put(deepLinkSearchSucess());
      }
      yield put(setHotelDetailLoading(false));
    }
  } catch (error) {
    let errorMsg = 'Hotel details not found.';
    if (error && error.response) {
      errorMsg = `${error.response.data.title || ''} ${error.response.data.detail || ''}`.trim();
    }
    yield put(getHotelFailure({ itinerary, error: errorMsg }));
    yield put(setHotelDetailLoading(false));
  }
}

function* getHotelWatcher() {
  yield takeEvery(getHotelRequest.toString(), getHotelWorker);
}

export default getHotelWatcher;
